import { render, staticRenderFns } from "./IcoWinnerPodium.vue?vue&type=template&id=232eaee8"
import script from "./IcoWinnerPodium.vue?vue&type=script&lang=js"
export * from "./IcoWinnerPodium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports